

import React from "react";
import { Navigate, useLocation } from "react-router-dom";

const ProtectedRoute = ({ children }) => {
  const location = useLocation();

  // 🔐 USER TOKEN ONLY (SHOP)
  const token = localStorage.getItem("token");

  if (!token) {
    return (
      <Navigate
        to="/MyAccountSignIn"
        replace
        state={{ from: location }}
      />
    );
  }

  return children;
};

export default ProtectedRoute;
